






























import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class DorisConfDetail extends Vue {
  @Prop() dorisConf!: any;
}
